(function () {
  if (window.ntMiniControlsReady) return;
  window.ntMiniControlsReady = true;
  var busy = false;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-mini-action]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    var panel = button.closest('[data-mini-section]');
    var row = button.closest('[data-mini-key]');
    var action = button.dataset.miniAction;
    var quantity = Number(row.dataset.miniQuantity);
    var next = action === 'remove' ? 0 : quantity + (action === 'plus' ? 1 : -1);
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var section = panel.dataset.miniSection;
    var committed = false;
    busy = true;
    panel.setAttribute('aria-busy', 'true');
    panel.querySelector('[data-mini-status]').textContent = 'Updating…';
    panel.querySelectorAll('[data-mini-action]').forEach(function (b) { b.disabled = true; });
    try {
      var response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id:row.dataset.miniKey,quantity:next,sections:[section],sections_url:location.pathname})
      });
      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update your cart. Please try again.');
      committed = true;
      var html = cart.sections && cart.sections[section];
      var parsed = new DOMParser().parseFromString(html || '', 'text/html');
      var replacement = parsed.querySelector('[data-mini-section]');
      if (!replacement) { location.reload(); return; }
      panel.replaceWith(replacement);
      document.querySelectorAll('[data-nt-cart-count]').forEach(function (el) { el.textContent=cart.item_count; el.hidden=!cart.item_count; });
      document.querySelectorAll('[data-nt-cart-tooltip]').forEach(function (el) { el.textContent='CART · '+cart.item_count+' '+(cart.item_count===1?'ITEM':'ITEMS'); });
      document.querySelectorAll('.nt-cart-link').forEach(function (el) { el.setAttribute('aria-label','Cart, '+cart.item_count+' items'); });
      var updatedRow = Array.from(replacement.querySelectorAll('[data-mini-key]')).find(function(el){return el.dataset.miniKey===row.dataset.miniKey;});
      var focusTarget = updatedRow && updatedRow.querySelector('[data-mini-action="'+action+'"]:not(:disabled)');
      focusTarget = focusTarget || replacement.querySelector('[data-mini-action]:not(:disabled),a');
      if (focusTarget) focusTarget.focus({preventScroll:true});
      replacement.querySelector('[data-mini-status]').textContent = 'Cart updated.';
      if (location.pathname.replace(/\/$/,'') === root.replace(/\/$/,'')+'/cart') location.reload();
    } catch (error) {
      panel.querySelector('[data-mini-status]').textContent = committed ? 'Cart updated. Refresh to see the latest total.' : error.message;
      panel.querySelectorAll('[data-mini-action]').forEach(function (b) { b.disabled = b.dataset.miniAction==='minus' && Number(b.closest('[data-mini-key]').dataset.miniQuantity)<=1; });
    } finally { busy=false; panel.removeAttribute('aria-busy'); }
  });
})();
